class MarqueeText extends HTMLElement {
  constructor() {
    super();
    this.marqueeContent = this.querySelector('.marquee-text__content');
    this.scrollSpeed = this.marqueeContent?.dataset.scrollSpeed || 'medium';
    this.scrollDirection = this.marqueeContent?.classList.contains('marquee-text__content--right') ? 'right' : 'left';
    
    this.init();
  }

  init() {
    if (!this.marqueeContent) return;
    
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.handleReducedMotion();
      return;
    }
    
    // Ensure smooth animation
    this.setupAnimation();
    
    // Handle window resize
    this.handleResize();
    
    // Animation runs continuously
  }

  setupAnimation() {
    // Ensure the animation is smooth and continuous
    this.marqueeContent.style.animationPlayState = 'running';
    
    // Force animation restart to ensure seamless loop
    this.marqueeContent.style.animation = 'none';
    this.marqueeContent.offsetHeight; // Trigger reflow
    this.marqueeContent.style.animation = null;
  }

  handleReducedMotion() {
    // For users who prefer reduced motion, show static text
    this.marqueeContent.style.animation = 'none';
    this.marqueeContent.style.transform = 'none';
    
    // Show only one instance of the text
    const items = this.marqueeContent.querySelectorAll('.marquee-text__item');
    items.forEach((item, index) => {
      if (index > 0) {
        item.style.display = 'none';
      }
    });
  }

  handleResize() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Restart animation on resize to ensure proper positioning
        this.marqueeContent.style.animation = 'none';
        this.marqueeContent.offsetHeight; // Trigger reflow
        this.setupAnimation();
      }, 100);
    });
  }

}

// Initialize marquee text components
document.addEventListener('DOMContentLoaded', () => {
  const marqueeTexts = document.querySelectorAll('.marquee-text');
  marqueeTexts.forEach(marquee => {
    new MarqueeText();
  });
});

// Handle dynamic content loading (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.theme) {
  document.addEventListener('shopify:section:load', (event) => {
    const marqueeText = event.target.querySelector('.marquee-text');
    if (marqueeText) {
      new MarqueeText();
    }
  });
}
